module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1015.8c5f16f0.jpg";